<template>
  <div id="sticky-top" class="container-fluid sticky">
    <div
      class="row menu"
      :class="{
        'menu--overlay': isTransparentAppearance,
        'menu--solid': isSolidAppearance,
      }"
    >
      <nav
        class="col navbar navbar-expand-lg menu__nav"
        :class="
          isTransparentAppearance
            ? 'navbar-dark menu__nav--overlay'
            : 'navbar-light menu__nav--solid'
        "
      >
        <router-link to="/home" class="navbar-brand brand-name">
          <img
            src="@/assets/brand/logo-square-transparent.webp"
            alt="logo web smart solution"
            width="70"
            class="mx-2"
          />
          <div class="naming">
            <p class="cunia">Institut Taxi</p>
            <div class="hr"></div>
            <p class="adam">formations taxi & vtc</p>
          </div>
        </router-link>

        <button
          class="navbar-toggler"
          type="button"
          aria-label="burger-button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarContent"
          @click="toggleMobileMenu"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <div
          id="navbarContent"
          class="collapse navbar-collapse mx-5"
          :class="{ 'menu__collapse--overlay': isTransparentAppearance }"
        >
          <ul
            class="navbar nav ms-auto flex-column flex-sm-row text-justify menu__ul sticky-top"
          >
            <li @click="closeMenu" class="nav-item">
              <router-link to="/home">Accueil</router-link>
              <div id="arrow_up" class="arrow_up"></div>
            </li>

            <li @click="closeMenu" class="nav-item">
              <router-link to="/formations-taxi-vtc"
                >Nos formations</router-link
              >
              <div id="arrow_up" class="arrow_up"></div>
            </li>

            <li @click="closeMenu" class="nav-item">
              <router-link to="/contact">Contact</router-link>
              <div id="arrow_up" class="arrow_up"></div>
            </li>

            <li @click="closeMenu" class="nav-item">
              <router-link to="/blog">Actualités</router-link>
              <div id="arrow_up" class="arrow_up"></div>
            </li>
          </ul>
          <div class="text-center">
            <BtnCallNav :is-overlay-mode="isTransparentAppearance" />
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import BtnCallNav from "@/components/partials/BtnCallNav.vue";

export default {
  name: "NavBase",
  components: { BtnCallNav },
  data() {
    return {
      isScrolled: false,
      isMobileMenuOpen: false,
      collapseElement: null,
    };
  },
  computed: {
    usesTransparentHeader() {
      const path = this.$route.path;

      return (
        path === "/" ||
        path === "/home" ||
        path.startsWith("/formations-taxi-vtc") ||
        path === "/contact" ||
        path === "/blog" ||
        path === "/formation-vtc-en-ligne" ||
        path === "/formation-taxi-en-ligne" ||
        path.startsWith("/article/")
      );
    },
    isOverlayMode() {
      return this.usesTransparentHeader && !this.isScrolled;
    },
    isTransparentAppearance() {
      return this.isOverlayMode && !this.isMobileMenuOpen;
    },
    isSolidAppearance() {
      return !this.isTransparentAppearance;
    },
  },

  mounted() {
    window.addEventListener("scroll", this.updateScroll);
    this.collapseElement = document.querySelector("#navbarContent");

    if (this.collapseElement) {
      this.collapseElement.addEventListener(
        "shown.bs.collapse",
        this.handleCollapseShown
      );
      this.collapseElement.addEventListener(
        "hidden.bs.collapse",
        this.handleCollapseHidden
      );
      this.syncMobileMenuState();
    }

    this.updateScroll();
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.updateScroll);

    if (this.collapseElement) {
      this.collapseElement.removeEventListener(
        "shown.bs.collapse",
        this.handleCollapseShown
      );
      this.collapseElement.removeEventListener(
        "hidden.bs.collapse",
        this.handleCollapseHidden
      );
    }
  },
  watch: {
    $route() {
      this.$nextTick(() => {
        window.requestAnimationFrame(() => {
          this.updateScroll();
          this.syncMobileMenuState();
        });
      });
    },
  },
  methods: {
    updateScroll() {
      this.isScrolled = window.scrollY > 32;
    },
    handleCollapseShown() {
      this.isMobileMenuOpen = true;
    },
    handleCollapseHidden() {
      this.isMobileMenuOpen = false;
    },
    toggleMobileMenu() {
      const collapse =
        this.collapseElement || document.querySelector("#navbarContent");

      this.isMobileMenuOpen = !(
        collapse && collapse.classList.contains("show")
      );
    },
    syncMobileMenuState() {
      const collapse =
        this.collapseElement || document.querySelector("#navbarContent");

      this.isMobileMenuOpen = !!collapse && collapse.classList.contains("show");
    },
    closeMenu() {
      // fermer le menu en utilisant le sélecteur Bootstrap
      const toggle = document.querySelector(".navbar-toggler");
      const collapse = document.querySelector("#navbarContent");
      if (toggle) {
        toggle.classList.remove("show");
      }
      if (collapse) {
        collapse.classList.remove("show");
      }

      this.isMobileMenuOpen = false;

      // déplacer la fenêtre du navigateur vers le haut de la page
      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.sticky {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 500;
}
.menu {
  transition: background-color 0.25s ease, box-shadow 0.25s ease,
    backdrop-filter 0.25s ease;

  &--overlay {
    background: transparent;
    box-shadow: none;
    backdrop-filter: none;
    -webkit-backdrop-filter: none;
  }

  &--solid {
    background: rgb(255, 250, 250);
    box-shadow: 0 10px 24px rgba(0, 16, 32, 0.08);
  }

  & .navbar-toggler {
    margin-right: 10px;
    transition: border-color 0.25s ease, background-color 0.25s ease;
  }
  & .brand-name {
    display: flex;
    justify-content: center;
    align-content: center;
    transition: opacity 0.25s ease;
    @media screen and (min-width: 992px) {
      margin: 5px 50px;
    }
  }
  & .naming {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    & .hr {
      width: 140px;
      height: 1px;
      transition: background-color 0.25s ease;
    }
    & p:first-of-type {
      font-size: 0.98rem;
      text-align: center;
      margin-bottom: 0.2px;
      transition: color 0.25s ease;
    }
    & p:last-of-type {
      font-size: 0.78rem;
      text-align: center;
      transition: color 0.25s ease;
    }
  }
  & ul {
    margin-right: 15px;
  }
  &__span {
    color: $color-text;
  }
  &__ul {
    padding: 5px 10px;

    @media screen and (max-width: 991.98px) {
      padding: 16px 10px 6px;
    }
  }
  & .nav-item {
    font-size: var(--type-ui);
    margin: 0px;
    padding: 0;
    width: 100%;
    border-radius: 5px;
    text-align: center;
    transition: background-color 0.25s ease, border-color 0.25s ease;
    @media screen and (min-width: 992px) {
      margin: 2px;
      padding: 10px 0px;
      width: fit-content;
      background-color: transparent;
      border: 1px solid transparent;
      transition: none;
    }
  }
  &__nav {
    margin-bottom: 0px;

    .navbar-collapse {
      @media screen and (max-width: 991.98px) {
        padding-top: 8px;
      }
    }

    & a:not(.brand-name) {
      display: block;
      width: 100%;
      padding: 14px 18px;
      text-decoration: none;
      transition: color 0.25s ease, text-decoration-color 0.25s ease;

      @media screen and (min-width: 992px) {
        width: auto;
        padding: 0px 5px;
      }
    }
  }

  &__collapse--overlay {
    @media screen and (max-width: 991.98px) {
      margin: 10px 14px 12px !important;
      padding: 8px 0 0;
      border: none;
      border-radius: 0;
      background: transparent;
      backdrop-filter: none;
      -webkit-backdrop-filter: none;
    }
  }
}

.menu--overlay {
  .navbar-toggler {
    border-color: rgba(255, 255, 255, 0.28);
    background: transparent;
  }

  .naming {
    .hr {
      background-color: rgba(255, 255, 255, 0.4);
    }

    p {
      color: rgba(255, 255, 255, 0.96);
    }
  }

  .nav-item {
    background-color: transparent;
    border: 1px solid transparent;

    @media screen and (max-width: 991.98px) {
      border: none;
    }
  }

  .menu__nav a:not(.brand-name) {
    color: rgba(255, 255, 255, 0.94);

    &:hover {
      text-decoration: underline rgba(255, 255, 255, 0.88);
      text-underline-offset: 4px;
    }

    &.router-link-exact-active {
      color: #fff;
    }
  }
}

.menu--solid {
  .naming {
    .hr {
      background-color: $color-text-grey;
    }

    p:first-of-type {
      color: $color-primary;
    }

    p:last-of-type {
      color: $color-text-grey;
    }
  }

  .nav-item {
    @media screen and (max-width: 991.98px) {
      background-color: $color-primary;
      border: 0.2px $color-secondary outset;
    }

    @media screen and (min-width: 992px) {
      background-color: transparent;
      border: 1px solid transparent;
    }
  }

  .menu__nav a:not(.brand-name) {
    color: $color-text-light;

    @media screen and (min-width: 992px) {
      color: $color-text;
    }

    &:hover {
      text-decoration: underline $color-secondary;
      text-underline-offset: 4px;
    }

    &.router-link-exact-active {
      color: $color-secondary;

      &:hover {
        @media screen and (min-width: 992px) {
          color: $color-primary;
        }
      }

      @media screen and (min-width: 992px) {
        color: $color-primary;
      }
    }
  }
}

.phone {
  border: 1px outset $color-primary;
  border-radius: 9%;
  font-size: var(--type-ui-small);
  margin-left: 20px;
  padding: 3px;
  & a {
    color: $color-primary;
    & a:hover {
      color: $color-text;
    }
  }
}

/*@media screen and (max-width: 992px) {
  .s-100 {
    height: 100vw;
  }
}
.active {
  position: relative;
  width: 30px;
  height: 20px;
  left: 16%;
  top: -58px;
  background-color: $color-primary;
  transform: rotate(45deg);
}*/
</style>
